module.exports = __webpack_public_path__ + "img/p3.b8336c51.jpg";